import type { ComponentProps, ReactNode } from 'react';
import { ActivityIndicator, Pressable, Text as RNText } from 'react-native';

import { cn } from '@/lib/design-system/cn';
import { tokens, type ButtonSize, type ButtonVariant } from '@/lib/design-system/tokens';
import { buttonSizeClass, buttonVariantClass } from '@/lib/design-system/variants';

export type ButtonProps = Omit<ComponentProps<typeof Pressable>, 'children'> & {
  variant?: ButtonVariant;
  size?: ButtonSize;
  label: string;
  loading?: boolean;
  icon?: ReactNode;
};

export function Button({
  variant = 'secondary',
  size = 'md',
  label,
  loading,
  disabled,
  icon,
  className,
  ...props
}: ButtonProps) {
  const isDisabled = disabled || loading;

  return (
    <Pressable
      className={cn(
        'cs-btn',
        buttonVariantClass[variant],
        buttonSizeClass[size],
        className,
      )}
      disabled={isDisabled}
      {...props}
    >
      {loading ? (
        <ActivityIndicator
          color={
            variant === 'primary' || variant === 'danger'
              ? tokens.colors['fg-inverse']
              : tokens.colors.fg
          }
          size="small"
        />
      ) : (
        <>
          {icon}
          <RNText
            className={cn(
              'font-medium',
              variant === 'primary' || variant === 'danger' ? 'text-fg-inverse' : 'text-fg',
            )}
            style={{ fontSize: 'inherit', lineHeight: 'inherit' }}
          >
            {label}
          </RNText>
        </>
      )}
    </Pressable>
  );
}
